import { SAVE_CREDENTIALS } from './actions';

const initialState = {
  credentials: {
    isLoaded: false,
    success: true,
  },
};

const value = (state = initialState, action) => {
  switch (action.type) {
    case SAVE_CREDENTIALS:
      return { ...state, credentials: { ...structuredClone(action.credentials), success: true, isLoaded: true } };
    default:
      return state;
  }
};

export default value;
